<template>
  <div id="app">
    <transition name="page">
        <router-view class="page"/>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      page_transition: 'ios',
      gradeClass: 'ios-device',
    };
  },
  created() {
    this.notScale();
    // ios-device for ios, android-device for android & other
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      this.gradeClass = 'ios-device';
    } else {
      this.gradeClass = 'android-device';
    }
    document.querySelector('body').className = this.gradeClass;
  },
  methods: {
    notScale() {
      document.addEventListener('gesturestart', (event) => {
        event.preventDefault();
      });
      document.documentElement.addEventListener('touchstart', (event) => {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      }, false);
      let lastTouchEnd = 0;
      document.documentElement.addEventListener('touchend', (event) => {
        const now = Date.now();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);
    },
  },
};
</script>
